import { IconShoppingCart, IconCash, IconChartBar, IconCalendar, IconPackage, IconTrendingUp, IconClipboardList, IconClock } from "@tabler/icons-react";
import { StatCard } from "../../../../components/common/stat-card";
import type { BuyerStatsDto, SellerStatsDto } from "../../../../api";

const DATE_FMT = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric" });
function fmtDate(iso?: string | null) {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : DATE_FMT.format(d);
}
function fmtNumber(n?: number | null) {
  return n != null ? n.toLocaleString("en-US") : "—";
}
function fmtCurrency(n?: number | null) {
  if (n == null) return "—";
  return n.toLocaleString("en-US", { maximumFractionDigits: 0 }) + " QAR";
}
function fmtDays(n?: number | null) {
  if (n == null) return "—";
  return `${n} day${n === 1 ? "" : "s"}`;
}

interface PartnerStatsStripProps {
  isBuyer: boolean;
  isSeller: boolean;
  buyer?: BuyerStatsDto | null;
  seller?: SellerStatsDto | null;
}

export function PartnerStatsStrip({ isBuyer, isSeller, buyer, seller }: PartnerStatsStripProps) {
  const buyerCards = (
    <>
      <StatCard icon={<IconShoppingCart size={18} />} label="Total Orders" value={fmtNumber(buyer?.orderCount)} />
      <StatCard icon={<IconCash size={18} />} label="Lifetime Spend" value={fmtCurrency(buyer?.lifetimeSpend)} />
      <StatCard icon={<IconChartBar size={18} />} label="Avg Order Value" value={fmtCurrency(buyer?.avgOrderValue)} />
      <StatCard icon={<IconCalendar size={18} />} label="Last Order Date" value={fmtDate(buyer?.lastOrderAt)} />
    </>
  );

  const sellerCards = (
    <>
      <StatCard icon={<IconPackage size={18} />} label="Active Products" value={fmtNumber(seller?.activeProductCount)} />
      <StatCard icon={<IconTrendingUp size={18} />} label="Total Sales" value={fmtNumber(seller?.totalSales)} />
      <StatCard icon={<IconClipboardList size={18} />} label="Open POs" value={fmtNumber(seller?.openPoCount)} />
      <StatCard icon={<IconClock size={18} />} label="Avg Fulfillment" value={fmtDays(seller?.avgFulfillmentDays)} />
    </>
  );

  if (isBuyer && isSeller) {
    return (
      <div className="flex flex-col gap-3">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-sm:grid-cols-1 max-sm:gap-3">{buyerCards}</div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-sm:grid-cols-1 max-sm:gap-3">{sellerCards}</div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-sm:grid-cols-1 max-sm:gap-3">
      {isBuyer ? buyerCards : sellerCards}
    </div>
  );
}
